import classNames from 'classnames'
import {useSelector} from 'react-redux'
import currencies from '../../../data/currencies.json'
import AmountManager from '../../../utils/amount'
import {SmsIcon} from '../../../icons'
import TextHelper from '../../../utils/text'

const ADDON_ICONS = {
    'sms-count-per-month': <SmsIcon />
}

const getAddonIcon = (key) => ADDON_ICONS[key?.split('#')[1]] ?? null

const AddOnsList = ({addOns, text}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const currency = currencies[addOns[0]?.currency]
    const totalAmount = addOns.reduce((sum, a) => sum + a.amount * a.quantity, 0)
    const interval = addOns[0]?.interval

    return (
        <div className={classNames('addons-list', {dark: isDarkMode})}>
            <div className="addons-header">
                <div className="addons-header-left">
                    <span className="addons-title">{text.add_ons}</span>
                    <span className="addons-subtitle">
                        {TextHelper.replaceAllChars(text.this_billing_cycle, ':count', addOns.length)}
                    </span>
                </div>
                <span className="addons-total-amount">
                    {AmountManager.normalizePrice(totalAmount, currency)}/{interval}
                </span>
            </div>

            <div className="addons-items">
                {addOns.map((addon, index) => (
                    <div key={index} className="addon-item">
                        <div className="addon-item-left">
                            {getAddonIcon(addon.add_on_key) && (
                                <span className="addon-item-icon">
                                    {getAddonIcon(addon.add_on_key)}
                                </span>
                            )}
                            <span className="addon-item-name">{addon.title}</span>
                            <span className="addon-item-meta">
                                {addon.quantity} {text.credits} · {AmountManager.normalizePrice(addon.amount, currency)} {text.per_credit}
                            </span>
                        </div>
                        <span className="addon-item-amount">
                            {AmountManager.normalizePrice(addon.amount * addon.quantity, currency)}
                            <span className="addon-item-interval">/{addon.interval}</span>
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AddOnsList